import moment from 'moment';
import setupDurationFormat from 'moment-duration-format';

setupDurationFormat(moment);

export default moment;
